const testimonials = [
  {
    name: "Jessica T.",
    location: "Newnan, GA",
    rating: 5,
    text: "My husband and I planned a 10-year anniversary trip to Italy and realized his passport had expired 3 weeks before departure. Fast Passport Center was incredible. We started online from our home in Newnan, shipped overnight, and had his renewed passport in 6 days. Worth every penny.",
    service: "Passport Renewal",
  },
  {
    name: "Brian K.",
    location: "Peachtree City, GA",
    rating: 5,
    text: "My daughter needed a passport for our Caribbean cruise and I had no idea both parents had to go to the clerk together. Fast Passport Center sent us the exact checklist, told us to visit the Newnan post office, and handled everything after that. We got it in 9 days — cruise saved!",
    service: "Child Passport",
  },
  {
    name: "Amanda R.",
    location: "Senoia, GA",
    rating: 5,
    text: "My passport was damaged from a washing machine mishap two weeks before a work conference in London. I thought I was stuck. Fast Passport Center walked me through the damaged passport replacement process, reviewed my documents, and got me a new one in 7 days. Shipped from Senoia overnight. Amazing service.",
    service: "Damaged Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function NewnanTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Newnan Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Newnan, Peachtree City, Senoia, and Coweta County who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}